import { render, staticRenderFns } from "./LoanDashboard.vue?vue&type=template&id=65146e54&scoped=true"
import script from "./LoanDashboard.vue?vue&type=script&lang=js"
export * from "./LoanDashboard.vue?vue&type=script&lang=js"
import style0 from "./LoanDashboard.vue?vue&type=style&index=0&id=65146e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65146e54",
  null
  
)

export default component.exports